import React, {Fragment} from 'react'


export default function TableRow({children, className, rowSpan}){
	return<> 
		<div className={"mst-row " + className} rowspan={rowSpan}>
			{children}
		</div>
	</>
}